export default (isValid, voucher) => {
  return {
    event: 'EMDasFOP',
    isValid: isValid ? 'Yes' : 'No',
    emdValue: isValid ? voucher.total : 'NA',
    'url_value': window.location.pathname,
    'type_reason': !isValid ? voucher.reason : 'Ok',
  };
};